module.exports = __webpack_public_path__ + "img/17_9.7711d703.png";